import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mapAlt"
const MapAltIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.842 3.605c1.162 0 2.105.943 2.105 2.106v10.831l-8.61-8.61a7.352 7.352 0 0 0 .189-1.664c0-.957-.21-1.863-.621-2.663h6.937ZM5.158 21.5a2.106 2.106 0 0 1-2.106-2.105v-7.516c.8 1.2 1.78 2.474 2.853 3.832l.831 1.052.822-1.052c1.4-1.737 2.631-3.348 3.505-4.832.358-.61.663-1.21.905-1.821l4.284 4.284L8.094 21.5H5.158Zm15.789-2.105a2.105 2.105 0 0 1-2.105 2.105H9.589L17 14.09l3.948 3.947v1.358h-.001Zm-14.21-4.21C3.988 11.636 2 8.973 2 6.31 2 3.658 4.105 1.5 6.736 1.5c2.632 0 4.737 2.158 4.737 4.81 0 2.664-1.968 5.327-4.737 8.874l.001.001ZM4.63 6.236a2.105 2.105 0 1 0 4.21 0 2.105 2.105 0 0 0-4.21 0Z" />
    </svg>
  )
}
export default MapAltIcon
